
$(document).ready(function(){
    
  var $sortabs = $('.sortabs').click(function() {
      if (this.id == 'all') {
        $('#hm_recipes .recipe_blurb').fadeIn(450);
      } else {
        var $el = $('.' + this.id).fadeIn(450);
        $('#hm_recipes .recipe_blurb').not($el).hide();
      }
      $sortabs.removeClass('active');
      $(this).addClass('active');
  })

  ///var elem = document.getElementById("upload-panel");

  $('#link-upload-panel').bind('click', function(){
    $('.upload-panel').slideToggle();
    $('#link-upload-panel').toggleClass("button-active");
    //elem.classList.toggle('hide');
  });

  $('.ae-select-content').text($('.dropdown-menu > li.selected').text());
  var newOptions = $('.dropdown-menu > li');
  newOptions.click(function() {
      $('.ae-select-content').text($(this).text());
      $('.dropdown-menu > li').removeClass('selected');
      $(this).addClass('selected');
  });

  var aeDropdown = $('.ae-dropdown');
  aeDropdown.click(function() {
      $('.dropdown-menu').toggleClass('ae-hide');
  });


  var vidPlayBtn = $('#rec_det_video_hld').find('.video-preview');
  //console.log(vidPlayBtn.length);
  //var currVidId;
  vidPlayBtn.each(function(){
    $(this).bind('click', function(e){
      var currVidId = $(this).parent().attr('vid_id');
      window.player.cueVideoById(currVidId);
      TweenMax.set('#player',{display:'block',opacity:0});
      TweenMax.to('#player',0.5,{opacity:1, ease:Cubic.easeInOut, onComplete:function(){
        window.playYoutubeVideo();
        window.unMuteYoutubeVideo();
      }});
    });
  });
  
  
  $("#rec_det_video_hld").slick({
    infinite: false,
    arrows: true,
    dots: false,
    fade:false,
    autoplay: false,
    speed:800,
    draggable:false,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnFocus:false,
    pauseOnHover:false,
    
  });
  $('#rec_det_video_hld').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    TweenMax.set('#player',{display:'none',opacity:0});
    window.stopYoutubeVideo();
    window.muteYoutubeVideo();
  });
});

$(window).on('resize', function(){
  $('#rec_det_video_hld')[0].slick.refresh();
});